import { render, staticRenderFns } from "./Assignee.vue?vue&type=template&id=71d04540&"
import script from "./Assignee.vue?vue&type=script&lang=js&"
export * from "./Assignee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports